import { PlayerSizesTypes } from '../../../common/store/store.types';

interface StylesObject {
    storiesContainerStyle: { [key: string]: any };
}

const getStoriesContainerStyle = (playerSize: PlayerSizesTypes) => ({
  marginLeft: '8px',
  marginRight: '8px',
  position: 'relative',
  height: playerSize === 'medium' ? '20px' : '28px',
  cursor: 'pointer',
  display: 'flex',
  pointerEvents: 'auto',
  justifyContent: 'space-between',
  flexDirection: 'row',
  columnGap: '6px',
  alignItems: 'center',
});

export const getStoriesSeekBarsStyleObject = (playerSize: PlayerSizesTypes): StylesObject => ({
  storiesContainerStyle: {
    ...getStoriesContainerStyle(playerSize),
  },
});
